if (typeof Object.values != 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "values", {
        value: function assign(target) {
            'use strict';
            if (target == null) { // TypeError if undefined or null
                throw new TypeError('Cannot convert undefined or null to object');
            }

            var result = [];
            for (var nextKey in target) {
                // Avoid bugs when hasOwnProperty is shadowed
                if (Object.prototype.hasOwnProperty.call(target, nextKey)) {
                    result.push(target[nextKey]);
                }
            }
            return result;
        },
        writable: true,
        configurable: true
    });
}



// WEBPACK FOOTER //
// ./app/jsmodel/Object.values.js